<div class="d-flex flex-column h-100">
  <div class="header">
    <h4 class="mb-4 h4 truncate-text sm-flex sm-items-center" i18n>
      <div>Activity Feed</div>
      <div *ngIf="title" class="animate-fade-in" data-test="activity-feed-subtitle">
        &nbsp;for {{ title }}
      </div>
      <cc-badge
        *ngIf="state === folderStates.Archived"
        text="Archived"
        type="warning"
        class="sm-ml-1"
        textSize="sm-text-sm"
        data-test="badge-heading"
      ></cc-badge>
      <cc-badge
        *ngIf="state === folderStates.Deleted"
        text="Deleted"
        type="error"
        class="sm-ml-1"
        textSize="sm-text-sm"
        data-test="badge-heading"
      ></cc-badge>
    </h4>
    <hr class="mb-0 hr" />
  </div>
  <div class="activities" *ngIf="activities.length > 0">
    <div class="pr-4 activity" *ngFor="let activity of activities">
      <div class="activity-header">
        <div class="activity-user">
          <cc-user-avatar [user]="activity.user"></cc-user-avatar>
          <div class="activity-user-name">{{ activity.user ? activity.user.fullName : 'Inactive User' }}</div>
          <div class="activity-user-team sm-flex sm-items-center" *ngIf="showTeam && activity.team">
            in
            <i
              class="cc-icon cc-icon-folder-closed-solid sm-ml-1 sm-mr-0.4 sm-text-secondary-text"
              *ngIf="activity.team.state === folderStates.Active"
              aria-hidden="true"
            ></i>
            <cc-badge
              *ngIf="activity.team.state === folderStates.Deleted"
              text="Deleted"
              icon="delete"
              type="error"
              class="sm-mx-1"
              textSize="sm-text-xs"
              data-test="badge-team-deleted"
            ></cc-badge>
            <cc-badge
              *ngIf="activity.team.state === folderStates.Archived"
              text="Archived"
              icon="archive"
              type="warning"
              class="sm-mx-1"
              textSize="sm-text-xs"
              data-test="badge-team-archived"
            ></cc-badge>
            <a
              *ngIf="activity.team.state !== folderStates.Deleted || isUserAdmin"
              [routerLink]="['/', 'home', 'teams', activity.team.id]"
              data-test="team-with-link"
            >
              {{ activity.team.name }}
            </a>
            <div *ngIf="activity.team.state === folderStates.Deleted && !isUserAdmin">
              {{ activity.team.name }}
            </div>
          </div>
          <div class="activity-user-team sm-flex sm-items-center" *ngIf="showProject && activity.project">
            in
            <i
              class="cc-icon cc-icon-folder-closed-solid sm-ml-1 sm-mr-0.4 sm-text-secondary-text"
              *ngIf="activity.project.state === folderStates.Active"
              aria-hidden="true"
            ></i>
            <cc-badge
              *ngIf="activity.project.state === folderStates.Deleted"
              text="Deleted"
              icon="delete"
              type="error"
              class="sm-mx-1"
              textSize="sm-text-xs"
              data-test="badge-project-deleted"
            ></cc-badge>
            <cc-badge
              *ngIf="activity.project.state === folderStates.Archived"
              text="Archived"
              icon="archive"
              type="warning"
              class="sm-mx-1"
              textSize="sm-text-xs"
              data-test="badge-project-archived"
            ></cc-badge>
            <a
              *ngIf="activity.project.state !== folderStates.Deleted || isUserAdmin"
              [routerLink]="['/', 'home', 'projects', activity.project.id]"
              data-test="project-with-link"
            >
              {{ activity.project.name }}
            </a>
            <div *ngIf="activity.project.state === folderStates.Deleted && !isUserAdmin">
              {{ activity.project.name }}
            </div>
          </div>
        </div>
        <div class="text-muted">
          <small placement="top" [ngbTooltip]="activity.createdAt | amDateFormat : 'lll'">
            {{ activity.createdAt | amTimeAgo }}
          </small>
        </div>
      </div>
      <div class="activity-content">
        <div [ngSwitch]="activity.kind">
          <div *ngSwitchCase="'UPLOAD_PHOTO'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-photo" aria-hidden="true"></i>
              <span class="activity-new" i18n>New</span>
              <span i18n class="activity-desc">Uploaded some photos:</span>
            </div>
            <div>
              <cc-form-photo-list
                maxDisplay="20"
                [photos]="activity.photos"
                [readOnly]="true"
                [item]="activity"
                (viewPhoto)="onViewPhoto($event)"
              ></cc-form-photo-list>
            </div>
          </div>
          <div *ngSwitchCase="'CREATE_FORM'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-form-template" aria-hidden="true"></i>
              <span class="activity-new" i18n>New</span>
              <span i18n class="activity-desc"
                >Created a new
                <a
                  *ngIf="checkIfTemplateNotInDeletedTeam(activity)"
                  (click)="onClickFormLink.emit()"
                  [routerLink]="['/', 'apps', activity.app.id, 'forms', activity.form]"
                  data-test="form-link"
                >
                  {{ activity.app.instanceName }}</a
                >
                <span *ngIf="checkIfTemplateInDeletedTeam(activity)">{{ activity.app.instanceName }}</span>
                <span *ngIf="!activity.app">Form</span>in
                <a
                  *ngIf="checkIfTemplateNotInDeletedTeam(activity)"
                  (click)="onClickTemplateLink.emit()"
                  [routerLink]="['/', 'apps', activity.app.id]"
                  data-test="template-link"
                  >{{ activity.app.name }}</a
                >
                <span *ngIf="checkIfTemplateInDeletedTeam(activity)">{{ activity.app.name }}</span>
                <span *ngIf="!activity.app">Template</span>
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'UPDATE_FORM'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-form-template" aria-hidden="true"></i>
              <span class="activity-edit" i18n>Edit</span>
              <span i18n class="activity-desc"
                >Updated this
                <a
                  *ngIf="checkIfTemplateNotInDeletedTeam(activity)"
                  (click)="onClickFormLink.emit()"
                  [routerLink]="['/', 'apps', activity.app.id, 'forms', activity.form]"
                  data-test="form-link"
                >
                  {{ activity.app.instanceName }}</a
                >
                <span *ngIf="checkIfTemplateInDeletedTeam(activity)">{{ activity.app.instanceName }}</span>
                <span *ngIf="!activity.app">Form</span>in
                <a
                  *ngIf="checkIfTemplateNotInDeletedTeam(activity)"
                  (click)="onClickTemplateLink.emit()"
                  [routerLink]="['/', 'apps', activity.app.id]"
                  data-test="template-link"
                  >{{ activity.app.name }}</a
                >
                <span *ngIf="checkIfTemplateInDeletedTeam(activity)">{{ activity.app.name }}</span>
                <span *ngIf="!activity.app">Template</span>
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'DELETE_PHOTO'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-photo" aria-hidden="true"></i>
              <span class="activity-remove" i18n>Remove</span>
              <span i18n class="activity-desc">Deleted some photos</span>
            </div>
          </div>
          <div *ngSwitchCase="'DELETE_FORM'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-form-template" aria-hidden="true"></i>
              <span class="activity-remove" i18n>Remove</span>
              <span i18n class="activity-desc"
                >Deleted a {{ activity.app.instanceName }} in
                <a
                  *ngIf="checkIfTemplateNotInDeletedTeam(activity)"
                  (click)="onClickTemplateLink.emit()"
                  [routerLink]="['/', 'apps', activity.app.id]"
                  data-test="template-link"
                  >{{ activity.app.name }}</a
                >
                <span *ngIf="checkIfTemplateInDeletedTeam(activity)">{{ activity.app.name }}</span></span
              >
            </div>
          </div>
          <div *ngSwitchCase="'CREATE_TEMPLATE'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-form-template" aria-hidden="true"></i>
              <span class="activity-new" i18n>New</span>
              <span class="activity-desc">
                <span i18n>Created a new</span>
                <span i18n *ngIf="activity.app && activity.app.isOrganisationTemplate"> organisation </span>
                <span i18n> template </span>
                <a
                  *ngIf="
                    activity.app &&
                    !activity.app.isOrganisationTemplate &&
                    activity.team.state !== folderStates.Deleted
                  "
                  (click)="onClickTemplateLink.emit()"
                  [routerLink]="['/', 'apps', activity.app.id]"
                  data-test="template-link"
                >
                  {{ activity.app.name }}</a
                >
                <span
                  *ngIf="
                    activity.app &&
                    (activity.app.isOrganisationTemplate || activity.team.state === folderStates.Deleted)
                  "
                  >{{ activity.app.name }}</span
                >
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'UPDATE_TEMPLATE'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-form-template" aria-hidden="true"></i>
              <span class="activity-edit" i18n>Edit</span>
              <span class="activity-desc">
                <span>Updated this </span>
                <span i18n *ngIf="activity.app && activity.app.isOrganisationTemplate"> organisation </span>
                <span i18n> template </span>
                <a
                  *ngIf="
                    activity.app &&
                    !activity.app.isOrganisationTemplate &&
                    activity.team.state !== folderStates.Deleted
                  "
                  (click)="onClickTemplateLink.emit()"
                  [routerLink]="['/', 'apps', activity.app.id]"
                  data-test="template-link"
                >
                  {{ activity.app.name }}</a
                >
                <span
                  *ngIf="
                    activity.app &&
                    (activity.app.isOrganisationTemplate || activity.team.state === folderStates.Deleted)
                  "
                  >{{ activity.app.name }}</span
                >
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'DELETE_TEMPLATE'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-form-template" aria-hidden="true"></i>
              <span class="activity-remove" i18n>Remove</span>
              <span i18n class="activity-desc"
                >Deleted this template {{ activity.app && activity.app.name }}</span
              >
            </div>
          </div>
          <div *ngSwitchCase="'CREATE_DASHBOARD'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-analytics" aria-hidden="true"></i>
              <span class="activity-new" i18n>New</span>
              <span i18n class="activity-desc"
                >Created a new dashboard
                <a
                  *ngIf="isDashboardNotDeletedOrInDeletedTeam(activity)"
                  [routerLink]="getRouterLinkToAnalyticsDashboard(activity)"
                  data-test="dashboard-link"
                >
                  {{ activity.dashboard.name }}</a
                >
                <span
                  *ngIf="activity.team && activity.dashboard && activity.team.state === folderStates.Deleted"
                >
                  {{ activity.dashboard.name }}</span
                >
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'UPDATE_DASHBOARD'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-analytics" aria-hidden="true"></i>
              <span class="activity-edit" i18n>Edit</span>
              <span i18n class="activity-desc"
                >Updated dashboard
                <a
                  *ngIf="isDashboardNotDeletedOrInDeletedTeam(activity)"
                  [routerLink]="getRouterLinkToAnalyticsDashboard(activity)"
                  data-test="dashboard-link"
                >
                  {{ activity.dashboard.name }}</a
                >
                <span
                  *ngIf="activity.team && activity.dashboard && activity.team.state === folderStates.Deleted"
                >
                  {{ activity.dashboard.name }}</span
                ></span
              >
            </div>
          </div>
          <div *ngSwitchCase="'DELETE_DASHBOARD'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-analytics" aria-hidden="true"></i>
              <span class="activity-remove" i18n>Remove</span>
              <span i18n class="activity-desc">Deleted a dashboard</span>
            </div>
          </div>

          <div *ngSwitchCase="'CREATE_CHART'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-chart-quantity" aria-hidden="true"></i>
              <span class="activity-new" i18n>New</span>
              <span i18n class="activity-desc"
                >Created a chart
                <span *ngIf="activity.dashboard">
                  in
                  <a
                    *ngIf="!activity.team || activity.team.state !== folderStates.Deleted"
                    [routerLink]="getRouterLinkToAnalyticsDashboard(activity)"
                    data-test="chart-dashboard-link"
                  >
                    {{ activity.dashboard.name }}</a
                  ><span *ngIf="activity.team && activity.team.state === folderStates.Deleted">
                    {{ activity.dashboard.name }}</span
                  ></span
                ></span
              >
            </div>
          </div>
          <div *ngSwitchCase="'UPDATE_CHART'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-chart-quantity" aria-hidden="true"></i>
              <span class="activity-edit" i18n>Edit</span>
              <span i18n class="activity-desc"
                >Updated a chart
                <span *ngIf="activity.dashboard">
                  in
                  <a
                    *ngIf="!activity.team || activity.team.state !== folderStates.Deleted"
                    [routerLink]="getRouterLinkToAnalyticsDashboard(activity)"
                    data-test="chart-dashboard-link"
                  >
                    {{ activity.dashboard.name }}</a
                  ><span *ngIf="activity.team && activity.team.state === folderStates.Deleted">
                    {{ activity.dashboard.name }}</span
                  ></span
                ></span
              >
            </div>
          </div>
          <div *ngSwitchCase="'DELETE_CHART'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-chart-quantity" aria-hidden="true"></i>
              <span class="activity-remove" i18n>Remove</span>
              <span i18n class="activity-desc"
                >Deleted a chart
                <span *ngIf="activity.dashboard">
                  in
                  <a
                    *ngIf="!activity.team || activity.team.state !== folderStates.Deleted"
                    [routerLink]="getRouterLinkToAnalyticsDashboard(activity)"
                    data-test="chart-dashboard-link"
                  >
                    {{ activity.dashboard.name }}</a
                  ><span *ngIf="activity.team && activity.team.state === folderStates.Deleted">
                    {{ activity.dashboard.name }}</span
                  ></span
                >
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'ADD_USER'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-users" aria-hidden="true"></i>
              <span class="activity-new" i18n>New</span>
              <span i18n class="activity-desc"
                >Added
                <span *ngIf="!activity.member">Inactive User</span>
                <span *ngIf="activity.member && activity.member.fullName">
                  {{ activity.member.fullName }}
                </span>
                <span *ngIf="activity.member && !activity.member.fullName">
                  {{ activity.member.email }}
                </span>
                <span *ngIf="activity.memberRole"> as {{ activity.memberRole }}</span>
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'REMOVE_USER'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-users" aria-hidden="true"></i>
              <span class="activity-remove" i18n>Remove</span>
              <span i18n class="activity-desc"
                >Removed
                <span *ngIf="!activity.member">Inactive User</span>
                <span *ngIf="activity.member && activity.member.fullName">
                  {{ activity.member.fullName }}
                </span>
                <span *ngIf="activity.member && !activity.member.fullName">
                  {{ activity.member.email }}
                </span>
              </span>
            </div>
          </div>
          <div *ngSwitchCase="'ACTIVATE_ACCOUNT'">
            <div class="activity-desc-wrapper">
              <i class="activity-icon cc-icon cc-icon-users" aria-hidden="true"></i>
              <span class="activity-new" i18n>New</span>
              <span i18n class="activity-desc">Activated the account</span>
            </div>
          </div>
        </div>
      </div>
      <hr class="hr" />
    </div>
    <div *ngIf="noMoreActivities" class="pb-4 no-more-activity-desc" i18n>
      There are no more activities to display
    </div>
    <div class="text-center" *ngIf="activities.length > 0 && !noMoreActivities">
      <button class="mb-3 btn btn-primary" (click)="viewMore()" [disabled]="loading">
        <span i18n>View more</span>
        <i class="cc-icon cc-icon-spinner-lg" *ngIf="loading" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div *ngIf="activities.length === 0 && noMoreActivities" class="activity-empty-state">
    <div class="activity-empty-state-header">
      <img
        class="mb-4 activity-empty-state-placeholder"
        src="assets/images/standing-man-with-tablet.svg"
        alt="man-holding-tablet-standing"
      />
      <h5 class="mb-3 h5 font-weight-bold" i18n>No activity yet</h5>
    </div>
  </div>
</div>
